import React from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getCurrentPatternThumbnailUri } from '../../reducers/currentPattern';
import { getCurrentPatternDesigner } from '../../reducers/designer';
import { getActiveFabric } from '../../reducers/fabrics';
import { getMessage } from '../../reducers/i18n';
import { getPattern } from '../../reducers/patterns';
import { getActiveSewpat } from '../../reducers/sewpats';
import AddToCart from '../addtocart/AddToCartScriptLoader';

import CategoriesTrail from '../categories/CategoriesTrail';
import CollapsableContainer from '../common/CollapsableContainer';
import SelectedValuesPane from '../common/SelectedValuesPane';
import Text from '../common/Text';
import Heading from '../heading/Heading';
import LinearProgress from '../LinearProgress';
import Recoloring from '../recoloring/Recoloring';
import SewpatDescription from '../sewpat/SewpatDescription';
import SizeHelp from '../sewpat/SewpatSizeHelp';
import SewpatSizesLevel from '../sewpat/SewpatSizesLevel';
import ActionBar from './ActionBar';
import FabricInfo from './FabricDescription';
import PatternColorPreview from './PatternColorPreview';
import PatternDescription from './PatternDescription';
import ExploreMore from './PatternExploreMore';
import PatternSewpatShortDescription from './PatternSewpatShortDescription';

const SinglePatternView = ({
    pattern, colors, designer, imgUri, path,
    isRecolorable, search, sewpatId, sewpat,
    fabric, fabricInfoPrefix, sewpatInfoLabel,
    previousLocation,
}) => {
    if (pattern && !pattern.title) {
        return <LinearProgress />;
    }
    return (
        <div itemScope itemType='http://schema.org/Product'>
            <meta itemProp='brand' content='www.schnoffle.de' />
            <meta itemProp='url' content={`https://www.schnoffle.de${path}`} />
            <Helmet>
                <meta property='og:type' content='product' />
                <meta
                    property='og:title'
                    content={`Dein Designerstück '${pattern.title}' - von Schnittmuster Berlin auf umfärbbaren Stoff von www.stoff.love | www.schnoffle.de`}
                />
                <meta property='og:brand' content='www.schnoffle.de' />
                <meta
                    property='og:description'
                    content={`Dein Designerstück ${pattern.title}. Schnitt von Schnittmuster Berlin, Stoff von www.stoff.love, Motive designt von ${designer.name}. ${pattern.description} Individuell einfärbbar in Deinen Wunschfarben. #schnoff #schnoffle #schnittmuster #schnittmusterberlin #deco #stofflove #stoffliebe`}
                />
                <meta
                    property='og:url'
                    content={`https://www.schnoffle.de${path}${search}`}
                />
                <meta property='product:price:amount' content='59.95' />
                <meta property='product:price:currency' content='EUR' />
                <meta property='og:availability' content='instock' />
                <meta
                    property='og:image'
                    content={imgUri}
                />
                <meta
                    property='og:image:alt'
                    content={pattern.title}
                />
                <meta property='og:image:type' content='image/jpeg' />
            </Helmet>
            <SelectedValuesPane
                sewpatId={sewpatId}
                previousLocation={previousLocation}
            />
            <Text>
                <CategoriesTrail />
                <Heading
                    text={<FormattedMessage
                        id='HEADING_SEWPAT_VIEW'
                        defaultMessage={'Dein \'{pattern}\' Designerstück'}
                        values={{ pattern: pattern.title }}
                    />}
                    level={3}
                />
                <PatternSewpatShortDescription
                    sewpatTitle={sewpat.title}
                    patternTitle={pattern.title}
                    patternId={pattern.id}
                    fabricLabel={fabric.title}
                    isRecolorable={isRecolorable}
                />

            </Text>
            <Text>
                {isRecolorable ? <Recoloring /> : null}
            </Text>
            <PatternColorPreview />
            <Text>
                <ActionBar />
            </Text>
            <AddToCart />
            <Text.Divider />
            <CollapsableContainer heading={sewpatInfoLabel}>
                <div>
                    <SewpatDescription sewpat={sewpat} />
                    <SewpatSizesLevel sewpat={sewpat} />
                </div>
            </CollapsableContainer>
            <CollapsableContainer
                heading={`${fabricInfoPrefix} ${fabric.title}`}
            >
                <FabricInfo fabric={fabric} />
            </CollapsableContainer>
            <SizeHelp />
            <Text>
                <Text.Divider />
                <PatternDescription
                    pattern={pattern} designer={designer}
                    sewpatId={sewpatId}
                />
                <Text.Divider />
                <ExploreMore
                    pattern={pattern} designer={designer}
                    sewpatId={sewpatId}
                />
            </Text>
        </div>
    );
};

const makeMapStateToProps = initialState => {
    const designer = getCurrentPatternDesigner(initialState);
    const path = initialState.location.pathname;
    const search = initialState.location.search
        ? `?${initialState.location.search}`
        : '';
    const sewpat = getActiveSewpat(initialState);
    const fabric = getActiveFabric(initialState);
    const fabricInfoPrefix = getMessage(initialState, 'FABRIC_INFO_TITLE');
    const sewpatInfoLabel = getMessage(initialState, 'SEWPAT_INFO_LABEL');
    const { patternid, sewpatId } = initialState.location.payload;
    const pattern = getPattern(initialState, patternid);
    const previousLocation = initialState.location.prev.type
        ? {
            type: initialState.location.prev.type,
            payload: initialState.location.prev.payload,
        }
        : {
            type: 'NAVIGATED_TO_SEWPAT_PATTERN_GALLERY',
            payload: { sewpatId },
        };
    const isRecolorable = (
        (
            pattern || {}
        ).metadata || {}
    ).recolorable;
    const imgUri = getCurrentPatternThumbnailUri(initialState, patternid);
    const mapStateToProps = state => (
        {
            pattern,
            isRecolorable,
            imgUri,
            designer,
            path,
            search,
            sewpatId,
            sewpat,
            fabric,
            fabricInfoPrefix,
            sewpatInfoLabel,
            previousLocation,
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(SinglePatternView);



// WEBPACK FOOTER //
// ./src/components/pattern/SinglePatternView.js